<template>
  <z-dialogo
    ref="dialogo"
    titulo="Transferências"
    largura="800px"
    altura="400px"
    persistent
    scrollable
    no-padding
    :dividers="true"
  >
    <template v-slot:texto>
      <v-data-table
        :headers="headers"
        :items="movimentos"
        :loading="carregando"
        hide-default-footer
        disabled-pagination
      >
        <template v-slot:item="{ item: transferencia }">
          <tr>
            <td>{{ transferencia.id }}</td>
            <td>{{ transferencia.data | dataBR }}</td>
            <td>{{ transferencia.loja ? transferencia.loja.abreviacao : '' }}</td>
            <td class="text-right">{{ transferencia.quantidade_total | valorBR(0) }}</td>
            <td class="text-right">{{ transferencia.valor_total | valorBR }}</td>
            <td class="text-center">
              <v-btn small color="primary" @click="confirmar(transferencia)">Confirmar</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <template v-slot:actions_right>
      <v-btn text @click="fechar">Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import movimentoApi from "@/app/services/movimentoestoque";

export default {
  name: "DialogoTransferencias",

  data() {
    return {
      headers: [
        { text: "Número", value: "id", width: "100px" },
        { text: "Data", value: "data" },
        { text: "Loja Origem", value: "loja.abreviacao" },
        { text: "Quantidade", value: "quantidade_total", align: "right" },
        { text: "Valor", value: "valor_total", align: "right" },
        { text: "Opções", value: "", align: "center", sortable: false },
      ],

      movimentos: [],
      carregando: false,
    };
  },

  computed: {
    name() {
      // return this.data;
    },
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("movimentoestoque", {
      abrirTransferencia: "abrir"
    }),


    abrir() {
      this.$refs.dialogo.abrir();
      this.carregarTransferencias();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    async carregarTransferencias() {
      try {
        this.carregando = true;
        this.movimentos = await movimentoApi.transferencias();
      } catch (error) {
        console.log(error);
      } finally {
        this.carregando = false;
      }
    },

    async confirmar(transferencia) {
      try {
        await this.abrirTransferencia(transferencia.id);
        this.$router.push({
          name: "EstoqueEditar",
          params: { id: transferencia.id },
        });
      } catch (error) {
        this.$eventbus.erro("Não foi possível abrir esta transferência.", error);
      } finally {
        this.LOADING_OFF();
      }
    }
  },

  watch: {
    data(newValue, oldValue) {},
  },
};
</script>

<style scoped></style>
